var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { REQUEST_SERVICE_UPDATE, REQUEST_VIDEO_ADD, REQUEST_VIDEO_DELETE, REQUEST_VIDEO_REORDER, SET_SERVICE, VIDEO_ADD, VIDEO_DELETE, VIDEO_REORDER, } from '../service/constants';
export var REQUEST_ERROR = '[ui] Request Error';
var initState = {
    loaders: {},
    errors: {},
};
export function serviceUiReducer(state, action) {
    if (state === void 0) { state = initState; }
    switch (action.type) {
        case REQUEST_SERVICE_UPDATE: {
            var key = action.payload.key;
            var loaders = __assign({}, state.loaders, (_a = {}, _a[key] = true, _a));
            return __assign({}, state, { loaders: loaders });
        }
        case SET_SERVICE: {
            var key = action.payload.field;
            return __assign({}, state, { loaders: __assign({}, state.loaders, (_b = {}, _b[key] = false, _b)), errors: __assign({}, state.errors, (_c = {}, _c[key] = undefined, _c)) });
        }
        case REQUEST_VIDEO_ADD:
        case REQUEST_VIDEO_REORDER:
        case REQUEST_VIDEO_DELETE:
            return __assign({}, state, { loaders: __assign({}, state.loaders, { videos: true }) });
        case VIDEO_ADD:
        case VIDEO_REORDER:
        case VIDEO_DELETE:
            return __assign({}, state, { loaders: __assign({}, state.loaders, { videos: false }), errors: __assign({}, state.errors, { videos: undefined }) });
        case REQUEST_ERROR:
            var _d = action.payload, errorMessage = _d.errorMessage, field = _d.field;
            return __assign({}, state, { errors: __assign({}, state.errors, (_e = {}, _e[field] = errorMessage, _e)), loaders: __assign({}, state.loaders, (_f = {}, _f[field] = false, _f)) });
        default:
            return state;
    }
    var _a, _b, _c, _e, _f;
}
var RequestErrorAction = /** @class */ (function () {
    function RequestErrorAction(payload) {
        this.payload = payload;
        this.type = REQUEST_ERROR;
    }
    return RequestErrorAction;
}());
export { RequestErrorAction };
